var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    group = _require$doc$builders.group,
    indent = _require$doc$builders.indent,
    line = _require$doc$builders.line;

var Conditional = {
  print: function print(_ref) {
    var path = _ref.path,
        _print = _ref.print;
    return group(concat([path.call(_print, 'condition'), indent(line), '? ', path.call(_print, 'trueExpression'), indent(line), ': ', path.call(_print, 'falseExpression')]));
  }
};
module.exports = Conditional;